import React, { useEffect } from "react";
import { uuid } from "../../helpers/common";

const SVGGeoShape = (props) => {
    const { height, width, color, color2, location, location2 } = props;
    if (!(location || location2)) return <></>;
    const id = uuid();

    const latLng2point = (item) => ({
        x: (item.lng + 180) * (256 / 360),
        y: (256 / 2) - (256 * Math.log(Math.tan((Math.PI / 4) + ((item.lat * Math.PI / 180) / 2))) / (2 * Math.PI))
    });

    const getSvgProps = (location) => {
        let point,
            svgPaths = [],
            minX = 256,
            minY = 256,
            maxX = 0,
            maxY = 0;

        let svgPath = [];
        location && location.forEach(item => {
            point = latLng2point(item);
            minX = Math.min(minX, point.x);
            minY = Math.min(minY, point.y);
            maxX = Math.max(maxX, point.x);
            maxY = Math.max(maxY, point.y);
            svgPath.push([point.x, point.y].join(','));
        })
        svgPaths.push(svgPath.join(' '))

        return {
            path: svgPath.length === 0 ? "" : 'M' + svgPaths.join('z M') + 'z',
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };

    }

    const drawPolygon = (node, props1, props2) => {
        if (!node) return;
        let g = document.createElementNS("http://www.w3.org/2000/svg", 'g');
        const appendPath = (path) => {
            const pathAttr = document.createElementNS("http://www.w3.org/2000/svg", 'path');
            pathAttr.setAttribute('d', path);
            g.innerHTML += pathAttr.outerHTML;
        }
        appendPath(props1.path);
        props2.forEach(props => appendPath(props.path));
        node.setAttribute('viewBox', [props1.x, props1.y, props1.width, props1.height].join(' '));
        node.innerHTML = g.outerHTML;
    }

    useEffect(() => {
        const svgProps1 = getSvgProps(location);
        const svgProps2 = Array.isArray(location2) ? location2.map(svgProps => getSvgProps(svgProps)) : [];
        drawPolygon(document.getElementById(`shape-location-${id}`), svgProps1, svgProps2);
    }, [location, location2])

    return <svg id={`shape-location-${id}`}
        className={`m-auto`}
        style={{ "--fillColor1": `${color}`, "--fillColor2": `${color2}` }}
        width={height || width ? width : "120px"}
        height={height || width ? height : "120px"}
        preserveAspectRatio="xMinYMin meet" />
}

export default SVGGeoShape;